var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-aside"},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":"2"}},_vm._l((_vm.bannnerdata),function(itemz,indexs){return _c('el-submenu',{key:indexs,staticClass:"avi",attrs:{"index":indexs + ''}},[_c('template',{slot:"title"},[_c('div',{class:{
          'online-img6': indexs == 0,
          'online-img': indexs == 1,
          'online-img2': indexs == 2,
          'online-img14': indexs == 3,
          'online-img3': indexs == 4,
          'online-img4': indexs == 5,
          'online-img5': indexs == 6,
          'online-img7': indexs == 7,
          'online-img9': indexs == 8,
          'online-img8': indexs == 9,
          'online-img10': indexs == 10,
          'online-img11': indexs == 11,
          'online-img12': indexs == 12,
          'online-img13': indexs == 13,
        }}),_c('span',[_vm._v(_vm._s(itemz.parentname))])]),_c('el-menu-item-group',_vm._l((itemz.children),function(items,indexz){return _c('el-menu-item',{key:indexz,class:_vm.$route.meta[0] === items.titlename ? 'isrouternav' : '',attrs:{"index":indexs + '-' + indexz},on:{"click":function($event){return _vm.tobannav(items)}}},[_vm._v(_vm._s(items.titlename))])}),1)],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }